import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d1e53fb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4d1e53fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e53fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d1e53fb')) {
      api.createRecord('4d1e53fb', component.options)
    } else {
      api.reload('4d1e53fb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d1e53fb&scoped=true&", function () {
      api.rerender('4d1e53fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/aiFunctionManage/aiFunctionServiceIntroduction/index.vue"
export default component.exports